// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"ebdb0b6c","667":"70d7361b","966":"365186b6"}[chunkId] + ".chunk.css";
};